import { FormikProps } from 'formik';
import { CardBody, CardHeader, Col, Input, Label } from 'reactstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { useTranslation } from 'react-i18next';
import {
  CustomerCreditInfo,
  CustomerFormType,
} from 'types/customer/customerTypes';
import useWindowSize from 'Components/Hooks/WindowSizeHook';

export default function CustomerCreditSection({
  formik,
}: {
  formik: FormikProps<CustomerFormType>;
}) {
  const { t } = useTranslation();
  const { showAllValidateErrors } = useSelector((s: RootState) => s.Customer);
  const { width } = useWindowSize();
  const isMobile = width <= 1024;

  const err = (path: keyof CustomerCreditInfo) =>
    ((formik.touched.customerCreditInfo as any)?.[path] &&
      (formik.errors.customerCreditInfo as any)?.[path] &&
      typeof (formik.errors.customerCreditInfo as any)[path] === 'string') ||
    (formik.isValid === false &&
      (formik.errors.customerCreditInfo as any)?.[path] &&
      showAllValidateErrors === true);

  return (
    <>
      <CardHeader className="mb-4 mx-0 px-0">
        <div
          className="px-0 mx-0"
          style={{
            fontSize: '1rem',
            fontWeight: '600',
            display: 'inline-flex',
          }}
        >
          <div className={`text-success`}>
            <i className="ri-user-settings-line"></i>
          </div>
          <div className="px-1">{t('Credit Information')}</div>
        </div>
      </CardHeader>
      <CardBody
        style={{
          paddingLeft: isMobile ? '' : '2rem',
          paddingRight: isMobile ? '' : '2rem',
        }}
      >
        <div className="mb-3 row">
          <Label
            htmlFor="customerCreditInfo.receivableLimit"
            className="col-sm-3 col-form-label"
          >
            {t('Receivable Limit')}
          </Label>
          <Col sm={9}>
            <Input
              type="number"
              inputMode="decimal"
              step="0.01"
              min="0"
              id="customerCreditInfo.receivableLimit"
              name="customerCreditInfo.receivableLimit"
              className="form-control"
              value={formik.values.customerCreditInfo.receivableLimit}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {err('receivableLimit') ? (
              <div className="text-danger">
                {(formik.errors.customerCreditInfo as any).receivableLimit}
              </div>
            ) : null}
          </Col>
        </div>

        <div className="mb-3 row">
          <Label
            htmlFor="customerCreditInfo.dateLimit"
            className="col-sm-3 col-form-label"
          >
            {/* {t('Overdue Days Limit')} */}
            {t('Date Limit')}
          </Label>
          <Col sm={9}>
            <Input
              type="number"
              inputMode="numeric"
              step="1"
              min="0"
              id="customerCreditInfo.dateLimit"
              name="customerCreditInfo.dateLimit"
              className="form-control"
              value={formik.values.customerCreditInfo.dateLimit}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {err('dateLimit') ? (
              <div className="text-danger">
                {(formik.errors.customerCreditInfo as any).dateLimit}
              </div>
            ) : null}
          </Col>
        </div>
        <div className="mb-3 row"></div>
      </CardBody>
    </>
  );
}
